import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class ShippingManifest implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fFactory: string,
    private fTrackingNumber: string,
    private fBulkShipmentIds: string[],
    private fCarrier: string,
    private fNotes?: string
  ) {
    [fId, fFactory, fTrackingNumber, fCarrier].forEach((arg, index) => {
      if (arg === undefined || arg === null) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get carrier(): string {
    return this.fCarrier;
  }

  get bulkShipmentIds(): string[] {
    return this.fBulkShipmentIds;
  }

  get factory(): string {
    return this.fFactory;
  }

  get trackingNumber(): string {
    return this.fTrackingNumber;
  }

  get notes(): string | undefined {
    return this.fNotes;
  }
}
